export enum SortOrder {
    ASC = 'asc',
    DESC = 'desc'
}

export enum ResponseStatus {
    NotAuthorized = 401,
    Forbidden = 403,
    NotFound = 404,
    Conflict = 409,
    Gone = 410,
    InternalServerError = 500,
}

export enum HttpRequestCustomHeaderNames {
    DisableLoader = 'Disable-Loader',
}

export enum HttpRequestCustomHeaderValues {
    LoaderDisabled = 'LoaderDisabled',
}

export enum StorageKeys {
    accessToken = 'accessToken',
    accessTokenExpiration = 'accessTokenExpiration',
    redirectPathname = 'redirectPathname',
}

export interface KeyValue {
    [key: string]: any;
}

export enum MediaErrors {
    NotAllowedError = 'NotAllowedError',
    EmptyError = 'EmptyError'
}

//// UserRoleEnum
export enum UserRoleEnum {
    PreHire = 1,
    Csba = 2,
    CsbaUSI = 21,
    CsbaUS = 22,
    FTE = 3,
    Employee = 4,
    EmployeeUSI = 41,
    EmployeeUS = 42,
    FrontDesk = 5,
    FrontDeskUSI = 51,
    Security = 6,
    SecurityUSI = 61,
    SecurityUS = 62,
    Facilitator = 7,
    FacilitatorUSI = 71,
    SeniorManager = 8,
    SeniorManagerUSI = 81,
    CTH = 9,
    EchoPartner = 10,
    IRCApprover = 11,
    ThirdPartyContractorApprover = 12,
    CLE = 13
}

export enum NavigationItemNames {
    BadgeRequests = 'Badge requests',
    PhotoReview = 'Photo review',
    UsersManagement = 'User management',
    BadgeValidityExtensions = 'Badge Validity Extensions',
    MobileBadging = 'Mobile badging',
    BulkProvision = 'Bulk provision',
    IndividualRequests = 'Individual requests',
    EmployeeSearch = 'Employee search',
    Locations = 'Location Configurations'
}

//// PhotoStatusEnum
export enum PhotoStatusEnum {
    MissingNotProvided = 1,
    ApprovalPending = 2,
    FurtherReview = 3,
    Approved = 4,
    ResubmissionPending = 5,
    OfferRescindedRejected = 6,
    Cancelled = 7
}

//// BadgeStatusEnum
export enum BadgeStatusEnum {
    Pending = 1,
    Printing = 2,
    CreatedInTransfer = 3,
    ReadyToPickUp = 4,
    Provided = 5,
    Creating = 6,
    ShippedTo = 7,
    Transfer = 8,
    PendingPhotoCompliance=20,
    LostInTransit = 19
}

export enum EReturnImageResizeType {
    dataUrl = 'dataUrl',
    blob = 'blob',
    file = 'file',
}

export enum BadgeRequestsCategoryId {
    All = 0,
    Prehire = 1,
    Employee = 2,
    Contractor = 3,
    MemberVisitor = 4,
    NonDeloitte = 5,
    FullTimeEmployee = 6,
    ContractorsOrInters = 7,
    CleContractors  = 8
}

export enum FileUploadAction {
    Cancel = 0,
    Delete = 1,
    Upload = 2,
}

export enum EEmployeeGroupDesc {
    External = 'External',
    Active = 'Active'
}

export enum AppConfigurationSettings {
    IsIndividualMobileBadgeEnabled = 'isIndividualMobileBadgeEnabled',
}


export enum ProfileRequestsCategory {
    MyRequests = 0,
    VisitorsRequests = 1,
    Contractors = 2,
    BadgeExtension = 3,
    CleContractors = 4
}

export enum EREQUEST_ACTION {
    edit = 'edit',
    copy = 'copy',
}
